// Client-side wrapper for the Thai service hub page.
// Kept separate from route modules so the heavy service catalog + longform
// prose load in the code-split component chunk, not the eager route bundle.
import { SERVICES, type ServiceId } from "@/data/services";
import { SERVICE_LONGFORM } from "@/data/service-longform";
import { ServiceHub, buildServiceJsonLd } from "@/components/ServiceHub";

const SITE = "https://nyclanguageinstitute.com";

export function ServiceHubRoute({ serviceId }: { serviceId: ServiceId }) {
  const s = SERVICES[serviceId];
  const url = `${SITE}/services/${s.slug}`;
  const intro = `${s.taglineTh} เริ่มต้น ฿${s.priceFrom.toLocaleString()} · ${s.turnaround} · พร้อมบริการครบวงจรในที่เดียว`;
  const jsonLd = buildServiceJsonLd(s, url);
  return (
    <>
      {jsonLd.map((node, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: node.children as string }}
        />
      ))}
      <ServiceHub s={s} intro={intro} longForm={SERVICE_LONGFORM[serviceId]} />
    </>
  );
}
